// @flow
import React from "react";
import { css } from "styled-components";
import { ButtonLink } from "@nested/component-library";
import { ResponsiveImage } from "../../components/ResponsiveImage";

import {
  type Props,
  getFirstWord,
  getTextWithoutFirstWord,
  textStyles,
} from "./shared";

const buttonsGroupStyles = css`
  background-color: ${({ theme }) => theme.palette.hague};
  display: flex;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.sand40};

  a {
    height: auto;
    line-height: 1em;
    padding: 15px;
    text-align: center;
    flex-grow: 1;

    &:not(:first-child) {
      margin-left: 10px;
    }
  }
`;

const imageWrapperStyles = css`
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 20px;
  width: 48%;
  z-index: 0;

  img {
    width: 100%;
    object-fit: cover;
    object-position: top right;
  }
`;

const contentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  max-width: 574px;
  margin: 0 auto;
  overflow: hidden;
  padding: 30px 20px;
  position: relative;

  h3,
  p {
    width: 60%;
  }
`;

export const MobileBuyingSellingSlice = ({
  buyingButtonLabel,
  buyingButtonLink,
  buyingImage,
  buyingText,
  buyingTitle,
  sellingButtonLabel,
  sellingButtonLink,
  sellingImage,
  sellingText,
  sellingTitle,
}: Props) => (
  <div css={textStyles}>
    <div
      css={css`
        ${contentWrapperStyles}
        align-items: flex-end;
        background-color: white;
      `}
    >
      <div
        css={css`
          ${imageWrapperStyles}
          right: 60%;
        `}
      >
        <ResponsiveImage src={sellingImage?.url} />
      </div>
      <h3>{sellingTitle}</h3>
      <p>
        <span>{getFirstWord(sellingText)}</span>{" "}
        {getTextWithoutFirstWord(sellingText)}
      </p>
    </div>
    <div
      css={css`
        ${contentWrapperStyles}
        background-color: ${({ theme }) => theme.palette.pink40};
      `}
    >
      <div
        css={css`
          ${imageWrapperStyles}
          left: 60%;

          img {
            object-position: top left;
          }
        `}
      >
        <ResponsiveImage src={buyingImage?.url} />
      </div>
      <h3>{buyingTitle}</h3>
      <p>
        <span>{getFirstWord(buyingText)}</span>{" "}
        {getTextWithoutFirstWord(buyingText)}
      </p>
    </div>
    <div css={buttonsGroupStyles}>
      <ButtonLink to={sellingButtonLink?.url || "/"} type="white">
        {sellingButtonLabel || "Missing label"}
      </ButtonLink>
      <ButtonLink to={buyingButtonLink?.url || "/"} type="white">
        {buyingButtonLabel || "Missing label"}
      </ButtonLink>
    </div>
  </div>
);
